<div class="MainContainer animated fadeIn">
    <div class="MainTitleBar">
        <p class="SectionTitle" style="margin-top: 0%;">{{ 'AccountSettingsPage.MyDetails' | translate }}</p>
    </div>

    <div class="MainBody">

        <mat-form-field class="example-full-width halfWidth">
            <mat-label>{{ 'AccountSettingsPage.UserID' | translate }}</mat-label>
            <input matInput disabled [(ngModel)]="this.parent.User.Id">
          </mat-form-field>

          <mat-form-field class="example-full-width halfWidth">
            <mat-label>{{ 'Login.Username' | translate }}</mat-label>
            <input matInput [(ngModel)]="this.parent.User.UserName">
          </mat-form-field>

          <mat-form-field class="example-full-width halfWidth">
            <mat-label>{{ 'AccountSettingsPage.Email' | translate }}</mat-label>
            <input matInput disabled [(ngModel)]="this.parent.User.Email">
          </mat-form-field>

          <mat-form-field class="example-full-width halfWidth">
            <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
            <input matInput [(ngModel)]="this.parent.User.Phone">
          </mat-form-field>

          <mat-form-field class="example-full-width halfWidth">
            <mat-label>{{ 'AccountSettingsPage.SecretToken' | translate }}</mat-label>
            <input matInput disabled [(ngModel)]="this.parent.User.Token">
          </mat-form-field>

          <button mat-raised-button (click)="ResetToken();">{{ 'AccountSettingsPage.ResetToken' | translate }}</button>

          <div class="fullWidthContainer">
            <mat-form-field class="example-full-width halfWidth">
                <mat-label>{{ 'AccountSettingsPage.Registered' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.EventRegisterUI">
              </mat-form-field>

              <mat-form-field class="example-full-width halfWidth">
                <mat-label>{{ 'AccountSettingsPage.MainRole' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.parent.User.Rights.MainRole.Meaning">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer" style="margin-bottom: 2%;">

              <mat-form-field class="example-full-width halfWidth">
                <mat-label>{{ 'TwilioID' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.TwilioID">
              </mat-form-field>

              <mat-form-field class="example-full-width halfWidth">
                <mat-label>{{ 'Name' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.UIName">
              </mat-form-field>
               
            </div>
        
                <div class="fullWidthContainer" style="margin-bottom: 2%;">

                  <div class="halfWidth">
                    <button mat-raised-button color="primary" (click)="UpdateUser();">{{ 'AccountSettingsPage.UpdateMyDetailsButton' | translate }}</button>
                  </div>
                  
                    <div class="halfWidth">
                      <p class="SectionTitle">{{ 'AccountSettingsPage.Settings' | translate }}</p>

                      <p class="SectionSubTitle">{{ 'AccountSettingsPage.DefaultLanguage' | translate }}:</p>
                      <!-- <mat-radio-group (change)="RadioChangeLanguage($event)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="this.parent.User.Settings.Language">
                        <mat-radio-button [checked]="lang.ID === this.parent.User.Settings.Language.ID" [value]="lang" class="LangRadio" *ngFor="let lang of this.parent.masterData.Languages; index as i">{{lang.Name}}</mat-radio-button>
                      </mat-radio-group> -->

                      <mat-form-field class="UserCompanyRolesSelect" appearance="outline">
                        <mat-label>{{ 'AccountSettingsPage.DefaultLanguage' | translate }}</mat-label>
                        <mat-select name="Department" [compareWith]="compareFn" [(ngModel)]="this.parent.User.Settings.Language">
                          <mat-option *ngFor="let lang of this.parent.masterData.Languages; index as i" [value]="lang" (click)="ChangeLanguage(lang);">
                            {{lang.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      
                      <div class="example-full-width" style="margin-top: 15px;">
                        <mat-slide-toggle (change)="AddUpdateUserSettings();" [(ngModel)]="this.parent.User.Settings.AutoAdjustVATNewProducts" matTooltip="{{ 'AutoAdjustVATNewProductsDesc' | translate }}" matTooltipClass='neutral-tool-tip'>{{ 'AutoAdjustVATNewProducts' | translate }}</mat-slide-toggle>
                      </div>

                      <div class="example-full-width" style="margin-top: 15px;">
                        <mat-slide-toggle (change)="AddUpdateUserSettings();" [(ngModel)]="this.parent.User.Settings.AutoAdjustProductQuantityOnDocuments" matTooltip="{{ 'AutoAdjustProductQuantityOnDocumentsDesc' | translate }}" matTooltipClass='neutral-tool-tip'>{{ 'AutoAdjustProductQuantityOnDocuments' | translate }}</mat-slide-toggle>
                      </div>

                      <div class="example-full-width" style="margin-top: 15px;">
                        <mat-slide-toggle (change)="AddUpdateUserSettings();" [(ngModel)]="this.parent.User.Settings.AutoAdjustProductPriceOnDocuments" matTooltip="{{ 'AutoAdjustProductPriceOnDocumentsDesc' | translate }}" matTooltipClass='neutral-tool-tip'>{{ 'AutoAdjustProductPriceOnDocuments' | translate }}</mat-slide-toggle>
                      </div>

                      <mat-form-field appearance="outline" style="margin-top: 50px;">
                        <mat-label>{{ 'StartingApplication' | translate }}</mat-label>
                        <mat-select name="u" [compareWith]="compareFn" [(ngModel)]="CurrentAccess">
                          <mat-option *ngFor="let access of this.UserAppAccess" [value]="access" (click)="UpdateUserLastSelectedApplication(access);">
                            <span>{{access.Application.Name}}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                    </div>
                </div>

                <p class="SectionTitle">{{ 'AccountSettingsPage.Security' | translate }}:</p>

                <div class="fullWidthContainer">
                  <mat-form-field class="halfWidth">
                    <input matInput placeholder="{{ 'AccountSettingsPage.OldPassword' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="this.Password" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
                </div>

               <div class="fullWidthContainer">
                  <mat-form-field class="halfWidth">
                    <input matInput placeholder="{{ 'AccountSettingsPage.NewPassword' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="this.NewPassword" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
                </div>

                <div class="fullWidthContainer">
                  <mat-form-field class="halfWidth">
                    <input matInput placeholder="{{ 'AccountSettingsPage.ConfirmNewPassword' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="this.ConfirmNewPassword" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
                </div>

                <div class="fullWidthContainer" style="margin-bottom: 2%;">
                  <button mat-raised-button color="primary" (click)="ChangeUserPassword();">{{ 'AccountSettingsPage.ChangePassword' | translate }}</button>
              </div>

                <p class="SectionTitle">{{ 'AccountSettingsPage.Companies' | translate }}</p>

                <div class="fullWidthContainer" *ngFor="let c of this.parent.User.Rights.AssignedCompanies; let index = index">
                  <div class="AssignedCompanies">
                    <mat-card class="example-card">
                      <mat-card-header>
                        <mat-card-title>{{c.Name}}</mat-card-title>
                        <mat-card-subtitle>{{c.VATNumber}}</mat-card-subtitle>
                        <mat-card-subtitle>{{c.COCRegisterNr}}</mat-card-subtitle>
                        <mat-card-subtitle *ngIf="c.RequestedAccess != null;">{{ 'AccountSettingsPage.AccessRequestedOn' | translate }} {{c.RequestedAccess.EventUI}}</mat-card-subtitle>
                        <mat-card-subtitle>
                          <div class="RequestedCompanyAddress" *ngIf="c.MainRole.ID > 0;">
                            <i class="material-icons">verified</i>
                          </div>
                        </mat-card-subtitle>
                      </mat-card-header>
                      <mat-card-actions *ngIf="c.RequestedAccess == null;">
                        <button style="margin-left: 5%;" mat-raised-button color="primary" *ngIf="c.MainRole.ID == 0;" (click)="RequestUserCompanyAccess(c);">{{ 'AccountSettingsPage.RequestAccess' | translate }}</button>
                        <button style="margin-left: 5%;" mat-stroked-button color="primary" *ngIf="c.MainRole.ID > 0;">{{ 'AccountSettingsPage.AccessLevel' | translate }} {{c.MainRole.Meaning}}</button>
                      </mat-card-actions>
                    </mat-card>
                  </div>
                </div>
    </div>
</div>